module.exports = __webpack_public_path__ + "static/sui-button-negative-a8c572c78a5854619f465a661687a959.png";